module.exports = __webpack_public_path__ + "img/2mob.aed2a89f.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":324,"height":180,"variants":[]};
}